var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6 10.2271C19.6 9.51804 19.5364 8.83624 19.4182 8.18164H10V12.0498H15.3818C15.15 13.2998 14.4455 14.3589 13.3864 15.068V17.5771H16.6182C18.5091 15.8362 19.6 13.2725 19.6 10.2271Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 20.0004C12.7009 20.0004 14.9645 19.1049 16.619 17.5777L13.3872 15.0686C12.4918 15.6686 11.3463 16.0231 10.0009 16.0231C7.39625 16.0231 5.19175 14.264 4.40535 11.9004H1.06445V14.4913C2.70995 17.7595 6.09175 20.0004 10.0009 20.0004Z",
    fill: "#128A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4045 11.8997C4.2045 11.2997 4.0909 10.6588 4.0909 9.99969C4.0909 9.34059 4.2045 8.69969 4.4045 8.09969V5.50879H1.0636C0.3864 6.85879 0 8.38609 0 9.99969C0 11.6133 0.3864 13.1406 1.0636 14.4906L4.4045 11.8997Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 3.9773C11.469 3.9773 12.7872 4.4818 13.8236 5.4727L16.6918 2.6045C14.96 0.9909 12.6963 0 10.0009 0C6.09175 0 2.70995 2.2409 1.06445 5.5091L4.40535 8.1C5.19175 5.7364 7.39625 3.9773 10.0009 3.9773Z",
    fill: "#DA0F1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f217cc2369a5cdaec02d2da29831c970.svg";
export { ForwardRef as ReactComponent };